import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-bold-receipt-2',
  imports: [],
  templateUrl: './icon-bold-receipt-2.component.html',
})
export class IconBoldReceipt2Component {
  @Input() color: string = 'currentColor';
  @Input() size: string = '24';
}
